module.exports = __webpack_public_path__ + "static/media/img.28a6d2e2.png";